import Endpoints from '@/config/ApiEndpoints.js';
import Axios from 'axios';
import LicenceCategories from "@/assets/json_data/licence_categories.json";
import { required, email, minLength, sameAs } from 'vuelidate/lib/validators';
import $ from "jquery";

export default {
	components:{

	},
	data() {
		return {
			assetsModule: false,
			ShowLoader: false,
			Saving: false,
			submitted: false,
			FileLoader: false,			
			file: '',
			Branches:{},
			NewTask: {				
				vehicle_id: '',
				assets_id: '',
				title: '',
				notes: '',
				date: '',
				time: '',
				location: '',				
				file: '',
				BookType:'',				
				Vehicle:[],				
				Asset:[],				
			},
			FleetSubscription:[],
			select_branch:true,
			FleetSubscriptionModules:[] ,
			Vehicles: [],      
      		Assets: [],    
		}
	},
	validations: {
	    NewTask: {
			title: { required },
			notes: { required },
			date: { required },			
			time: { required },			
			location: { required },			
			BookType: { required },			
	    },
  	},
	mounted() {						
		document.title = pbx_SiteTitle+' - Book Service Appointment';
		let CompanyData = JSON.parse(localStorage.getItem('Company'));
		this.NewTask.company_name = CompanyData.name;
		this.GetCompanySubscriptionModule();				
		this.GetVehiclesList();
		this.GetAssetsList();		
	},

	methods : {	
		GetCompanySubscriptionModule() {
        	var FleetSubscription = JSON.parse(localStorage.getItem("FleetSubscription"));
			var fleet_modules = JSON.parse(FleetSubscription["fleet_modules"]);
			const isAssets = fleet_modules["Assets"];
			if (isAssets) {
				this.assetsModule = true;
			}		
      	},	
		GetVehiclesList(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Vehicle.List, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
		GetAssetsList(type = "") {
	      var obj = { token: localStorage.getItem("token") };	      
	      Axios.post(Endpoints.Assets.List, obj).then((Response) => {
	        if (Response?.data?.success) {
	          this.Assets = Response.data.AssetsList;	          
	        }
	      });
	    },
		handleFileUpload() {
      		this.file = this.$refs.file.files[0];
    	},
		CreateTaskData() {
			this.submitted = true;
	      	this.$v.$touch();
	      	//console.log(this.NewTask);
	      	if (this.$v.$invalid) {
	        	return;
	      	}
	      	this.Saving = true;
			let formData = new FormData();
			if (this.$refs.file && this.$refs.file.files[0]) {
			formData.append('token', localStorage.getItem('token'));
			formData.append('storage_type', 'CFD');
			formData.append('file', this.file);
			Axios.post(Endpoints.File.Upload, formData).then((Response) => {
				this.Saving = false;
				if (Response?.data?.success == true) {
				  	this.NewTask.file = Response.data.file;
				  	this.CreateTask();
				} else {
					this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
				}
			});
		}else{
			this.CreateTask();
		}
    	},		
		CreateTask() {			
	      	Axios.post(Endpoints.Task.BookServiceAppointment, {token: localStorage.getItem('token'),...this.NewTask}).then((Response) => {
	        	this.Saving = false;
	        	if (Response?.data?.success) {
					this.$swal.fire('Service Appointment Created Successfully', '', 'success').then(() => {
	            		this.$router.push('/dashboard/home');
	          		});
	        	} else {
					this.$swal.fire({
	            		title: 'Oops!',
	            		text: Response?.data?.message || "Something went wrong",
	            		icon: 'error',
	            		confirmButtonText: 'Close',
	          		});
        		}
	      	});
    	},

	}
}
